import React from 'react';
import RegisterIndividualPageBody from '../components/RegisterIndividualPageBody';

function RegisterIndividualPage() {
    return <RegisterIndividualPageBody />;
}

export default RegisterIndividualPage;